<template>
  <app-button label="Cart" :icon="true" type="plain" :class="{'PaB-cart-button': true, 'PaB-item-added': newItem}"
    @click.native="viewCart">
    <template slot="after">
      <span class="PaB-cart-counter" v-if="cartCount">{{cartCount}}</span>
      <icon-base icon-name="Cart">
        <icon-cart />
      </icon-base>
    </template>
  </app-button>
</template>

<style lang="scss" scoped>
.PaB-cart-button {
  position: relative;
  margin-left: auto;
}
.PaB-cart-counter {
  font-size: 0.75em;
  position: absolute;
  bottom: 50%;
  right: 15px;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 4px;
  transition: transform 0.2s ease-in-out;
}
.PaB-item-added .PaB-cart-counter {
  transform: scale(1.3) translateY(-2px);
}
</style>

<script>
import AppButton from '@/components/AppButton'
import IconBase from '@/components/IconBase'
import IconCart from '@/components/icons/IconCart'

export default {
  components: {
    AppButton,
    IconBase,
    IconCart
  },
  data () {
    return {
      newItem: false,
      a2cTimer: null
    }
  },
  computed: {
    cartCount () {
      return this.$store.getters['cart/getCartCount']
    }
  },
  methods: {
    viewCart () {
      const currentRoute = this.$router.currentRoute.fullPath.replace(/\/$/, '')
      this.$router.push(`${currentRoute}/cart`)
    },
    timeoutNewItem () {
      this.newItem = false
    }
  },
  watch: {
    cartCount () {
      this.newItem = true
      clearTimeout(this.a2cTimer)

      this.a2cTimer = setTimeout(this.timeoutNewItem, 200)
    }
  }
}
</script>
